import { Box, Stack, useToast } from '@chakra-ui/react';
import React from 'react';
import UploadedImage from './UploadedImage';
import UploadImageUI from './UploadImageUI';
import ImageUploading from 'react-images-uploading';
import { scrollBarStyle } from '../../../utils/layoutConfig';
import { useMutation } from '@apollo/client';
import queries from '../../../utils/query';
import { selectImages, setImages } from '../../../redux/imagesSlice';
import { useSelector } from 'react-redux';

const ImageAccordion = ({ viewId }) => {
	const images = useSelector(selectImages);
	const toast = useToast();
	const [updateViewImages, { loading: mutationLoading, error: mutationError }] = useMutation(
		queries.UPDATE_VIEW_IMAGES,
	);
	const [uploadImage, setUploadImage] = React.useState([]);
	const maxNumber = 1;
	const updateRedux = setImages;

	React.useEffect(() => {
		if (images) {
			updateViewImages({
				variables: {
					viewId: String(viewId),
					images: JSON.stringify(images),
				},
			});
		}
	}, [images]);

	React.useEffect(() => {
		if (mutationError) {
			toast(mutationErrorMessage);
		}
	}, [mutationError]);

	console.log(images);

	return (
		<Box>
			<Stack pr={1} maxH={'500px'} overflow="auto" sx={scrollBarStyle}>
				<ImageUploading
					onChange={setUploadImage}
					value={uploadImage}
					maxNumber={maxNumber}
					dataURLKey="data_url"
					acceptType={['jpg', 'png', 'jpeg', 'gif']}
				>
					{(imageUploadProps) => (
						<UploadImageUI
							{...{
								...imageUploadProps,
								uploadImage,
								setUploadImage,
								images,
								updateRedux,
								isLoading: mutationLoading,
							}}
						/>
					)}
				</ImageUploading>
				{images?.map((image, index) => (
					<UploadedImage key={'image-upload-image-' + index} {...{ image, index, images, updateRedux }} />
				))}
			</Stack>
		</Box>
	);
};

export default ImageAccordion;

const mutationErrorMessage = {
	title: 'Ocorreu um erro ao tentar salvar as imagens no banco',
	status: 'error',
	duration: '4000',
	isClosable: true,
};
